import { styled } from "@mui/system";

const logo = new URL("../../assets/images/logo.png", import.meta.url);

const MUILogoImage = styled("div")({
  backgroundImage: `url("${logo}")`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  width: "32rem",
  height: "18rem",
  marginBottom: "6rem",

  "@media screen and (orientation: landscape)": {
    marginBottom: "2rem",
    width: "20rem",
    height: "11.25rem",
  },
});

interface LogoImageProps {
  style?: React.CSSProperties;
}
const LogoImage = (props: LogoImageProps) => (
  <MUILogoImage {...props} />
);

export default LogoImage;